/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

// Chakra Imports
import {
  Flex,
  Stack,
  Box,
  useColorMode,
  IconButton,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
// Custom Icons
import { SettingsIcon } from "components/Icons/Icons";
// Custom Components
import { SidebarResponsive } from "components/Sidebar/Sidebar";
import Notifications from "components/Notifications/Notifications";
import { getCurrentUser } from "services/authService";
import React, { useState, useEffect } from "react";
// ✅ Doğru import
import routes from "routes/dashRoutes";

// ✅ Yeni logo importları
import LogoColored from "assets/svg/logo-colored.svg";
import LogoWhite from "assets/svg/logo-white.svg";

export default function HeaderLinks(props) {
  // Filter out non-DOM props to avoid React warnings
  const { variant, children, fixed, scrolled, secondary, onOpen, brandText, staticContext, onSidebarToggle, ...rest } = props;
  const { colorMode } = useColorMode();
  const [userRole, setUserRole] = useState(null);
  const [userBayiTipi, setUserBayiTipi] = useState(null);

  // Kullanıcı rolünü ve bayi_tipi'ni yükle
  useEffect(() => {
    getCurrentUser()
      .then((user) => {
        setUserRole(user.role);
        setUserBayiTipi(user.bayi_tipi);
      })
      .catch(() => {
        setUserRole(null);
        setUserBayiTipi(null);
      });
  }, []);

  // İkon rengi: koyu gri
  const iconColor = "gray.700";
  
  // Bildirimler sadece admin ve saas_bayi için göster
  const canSeeNotifications = userRole === "admin" || (userRole === "bayi" && userBayiTipi === "saas_bayi");

  return (
    <Flex
      pe={{ sm: "0px", md: "16px" }}
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
    >
      {/* ✅ SidebarResponsive logosu düzeltildi */}
      <SidebarResponsive
        hamburgerColor={"white"}
        logo={
          <Stack direction="row" spacing="12px" align="center" justify="center">
            <img
              src={colorMode === "dark" ? LogoWhite : LogoColored}
              alt="ixpilot logo"
              height="30"
              style={{ maxHeight: "30px" }}
            />
          </Stack>
        }
        colorMode={colorMode}
        secondary={props.secondary}
        routes={routes}
        {...rest}
      />

      {/* Masaüstü Sidebar Toggle Butonu */}
      {onSidebarToggle && (
        <IconButton
          aria-label="Toggle sidebar"
          icon={<HamburgerIcon />}
          variant="ghost"
          onClick={onSidebarToggle}
          display={{ base: "none", xl: "flex" }}
          ms={{ base: "4px", xl: "4px" }}
          me="4px"
          color={iconColor}
          fontSize="20px"
          _hover={{ 
            bg: "rgba(0, 0, 0, 0.05)",
            transform: "scale(1.1)"
          }}
          _active={{ transform: "scale(0.95)" }}
          transition="all 0.2s"
        />
      )}

      {/* Bildirimler - Sadece admin ve saas_bayi için */}
      {canSeeNotifications && (
        <Box me="4px">
          <Notifications />
        </Box>
      )}

      {/* SettingsIcon sadece development modunda göster */}
      {process.env.NODE_ENV === 'development' && (
        <Box
          as="button"
          onClick={props.onOpen}
          me="4px"
          cursor="pointer"
          _hover={{ 
            bg: "rgba(0, 0, 0, 0.05)",
            transform: "scale(1.1)",
            borderRadius: "md"
          }}
          _active={{ transform: "scale(0.95)" }}
          transition="all 0.2s"
          p={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <SettingsIcon
            color={iconColor}
            w="20px"
            h="20px"
        />
        </Box>
      )}
    </Flex>
  );
}
